import { rankWith, isObjectControl, isControl } from '@jsonforms/core';
import type {
  UISchemaElement,
  JsonSchema,
  TesterContext,
} from '@jsonforms/core';

export const createCountryGreetingTester = (propertyName: string) =>
  rankWith(
    4,
    (uischema: UISchemaElement, schema: JsonSchema, context: TesterContext) =>
      isControl(uischema) &&
      isObjectControl(uischema, schema, context) &&
      uischema.scope.endsWith(propertyName)
  );

export const countryGreetingTester = createCountryGreetingTester(
  'initialStaticWidgetGreeting'
);
export const staticWidgetDescriptionMessageTester = createCountryGreetingTester(
  'staticWidgetDescriptionMessage'
);
export const staticWidgetLoaderMessageTester = createCountryGreetingTester(
  'staticWidgetLoaderMessage'
);
